import { useCallback, useRef } from 'react';

import { Noop } from '@hsp/utilities';

import { convertSorts } from '@c/table/utilities/convert-sorts.util';

import { ISort } from '@t/api/common';

import { ITableContext } from 'types/components/table/context.type';
import { TableContextReturnType } from 'types/components/table/context-return.type';

export const useTableStore = <TData = unknown>(sorts?: ISort<TData>[]): TableContextReturnType => {
  const store = useRef<ITableContext>({
    globalFilter: '',
    hasNextPage: false,
    hasPreviousPage: false,
    numberOfPages: 0,
    page: 1,
    pageSize: 10,
    sorting: convertSorts(sorts),
    total: 0,
  });

  const subscribers = useRef<Set<Noop>>(new Set());

  const get = useCallback(() => store.current, []);
  const set = useCallback((value: Partial<ITableContext>) => {
    store.current = { ...store.current, ...value };
    subscribers.current.forEach((callback) => callback());
  }, []);
  const subscribe = useCallback((callback: Noop) => {
    subscribers.current.add(callback);

    return () => {
      subscribers.current.delete(callback);
    };
  }, []);

  return {
    get,
    set,
    subscribe,
  };
};
